export const SetURLParameters = (parameters) => {
    const url = window.location.href
    const resUrl = url.split("?")
    const parametersURL = []

    Object.keys(parameters).forEach(key => {
        let parameter = parameters[key]
        if(parameter)
        parametersURL.push(`${key}=${encodeURIComponent(parameter)}`)
    })

    let parametersURLString = '?' + parametersURL.join('&')

    if(parametersURL.length === 0)
    parametersURLString = ''

    let newURL = resUrl[0]+parametersURLString
    if(url === newURL) return

    window.history.pushState(parameters, "Hide", newURL);
}

export const jsonToParameters = parameters => {
    const parametersURL = []

    Object.keys(parameters).forEach(key => {
        let parameter = parameters[key]
        if(parameter)
        parametersURL.push(`${key}=${encodeURIComponent(parameter)}`)
    })

    return parametersURL.join('&')
}

export const GetURLParameters = () => {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
    function(m,key,value) {
      vars[key] = decodeURIComponent(value.replace(/\+/g, ' '));
    })
    return vars;
}

export const URLChangeListener = (listener) => {
    window.onpopstate = function(event) {
        listener(GetURLParameters())
    };
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/helpers/Url.js